var _defs, _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoreSheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.2}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.5,30.8668V6.5a2,2,0,0,0-2-2h-27a2,2,0,0,0-2,2v35a2,2,0,0,0,2,2h27a2,2,0,0,0,2-2V40.0311"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.1342,37.66,21.2877,21.7746V17.25H25.92L41.7049,33.0776"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44.3148,37.9846a1.6234,1.6234,0,0,0,0-2.2906l-2.61-2.6164L37.1342,37.66l2.61,2.6164a1.6136,1.6136,0,0,0,2.2849,0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13,
    y1: 10.5,
    x2: 35,
    y2: 10.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13,
    y1: 17.25,
    x2: 21.2877,
    y2: 17.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 32.6516,
    y1: 24,
    x2: 35,
    y2: 24
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13,
    y1: 24,
    x2: 23.5077,
    y2: 24
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13,
    y1: 30.75,
    x2: 29.989,
    y2: 30.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13,
    y1: 37.5,
    x2: 35,
    y2: 37.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreSheets);
export default __webpack_public_path__ + "static/media/score-sheets.2a879cdd69fc3c0c7503eb792531b2db.svg";
export { ForwardRef as ReactComponent };